import React, { Component, Fragment } from "react";
import TitledForm from "../../../Helpers/TitledForm";
import { Redirect } from "react-router";
import FormView from "../../../FormView";
import FormNavigator from "../../../Helpers/FormNavigator";
import LocationFields from "../../LocationFields";
import ApartmentTypeFields from "../../ApartmentTypeFields";
import ProfileFields from "../../ProfileFields";
import SignUpForm from "../../Form";
import Progress from "../../../SidePanel/Progress";
import "./LandlordProperty.css"
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { submit, reset, reduxForm, getFormValues } from "redux-form";
import { requestState } from "../../../../actions/utils";
import { CircularProgress } from "@material-ui/core";
import { setAnnouncementState } from "../../../../actions/landlordActions";
import { propertyFields, validateProperty } from "../../../../actions/validation";

const steps = [
    {
        title: "Where is your property located?",
        nav: "Location",
        PageFields: LocationFields
    },
    {
        title: "Interior Design",
        subtitle: "Input the interior details of your property:",
        nav: "Interior Design",
        PageFields: ApartmentTypeFields,
        props: { mode: "interior" }
    },
    {
        title: "Facilities & Security",
        subtitle: "Input the security and facility details:",
        nav: "Facilities & Security",
        PageFields: ApartmentTypeFields,
        props: { mode: "security" }
    },
    {
        title: "Provide information of your preferred tenant:",
        nav: "Tenant Profile",
        PageFields: ProfileFields,
        props: {
            preferred: true
        }
    }
]

class LandlordProperty extends Component {

    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        form: PropTypes.string.isRequired,
        baseResource: PropTypes.string.isRequired,
        onChange: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.setValidity = this.setValidity.bind(this);
        this.state = {
            validity: undefined,
            max: 0
        }
    }

    setValidity(values) {
        if (!values) return;
        const validity = validateProperty(values, true);
        const keys = Object.keys(validity);
        let earliestError = undefined;
        if (keys.length > 0) {
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                for (let j = 0; j < propertyFields.length; j++) {
                    if (propertyFields[j][key] === true) {
                        earliestError = earliestError === undefined ? j : Math.min(j, earliestError);
                        break;
                    }
                }
            }
        }
        const max = (earliestError === undefined) ? Number.POSITIVE_INFINITY : earliestError;
        // console.log( 'VALIDITY >>', validity, 'MAX >>', max ); // DEBUG
        this.setState({
            validity,
            max
        });
    }

    isValid(validity) {
        return validity !== undefined && !Object.keys(validity).length;
    }

    handleChange(values, dispatch, props, previousValues) {
        this.setValidity(values);
        if (this.props.onChange)
            this.props.onChange(values, dispatch, props, previousValues);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.formValues !== this.props.formValues) {
            this.setValidity(this.props.formValues);
        }
    }

    render() {
        const index = Number(this.props.match.params.index);
        const { handleSubmit, form, baseResource, announcementState, resetState } = this.props;
        const disableProgress = this.state.max <= index;
        const resource = `${baseResource}/new`;

        if (index < 0 || index >= steps.length)
            return <Redirect to={baseResource} />;

        const { title, subtitle } = steps[index] || {};

        const isFirst = index <= 0;
        const formProps = {
            landlord: true,
            onSubmit: this.props.onSubmit,
            onChange: this.handleChange,
            validity: this.state.validity,
            dispatch: this.props.dispatch,
            ...(steps[index].props || {})
        };

        const isLast = index >= (steps.length - 1);

        if (announcementState === requestState.ok) {
            resetState(form);
            return <Redirect push to="/user/announcements" />;
        }

        return (
            <FormView
                split35
                content={
                    <TitledForm
                        stretch
                        titleAlign="left"
                        titleSize="wide"
                        formSize="wide"
                        formAlign="stretch"
                        title={title}
                        subtitle={subtitle}
                        form={
                            <SignUpForm form={form} step={steps[index]} validity={this.state.validity} {...formProps} />
                        }
                        footer={
                            <Fragment>
                                {announcementState === requestState.inProgress &&
                                    <CircularProgress color="primary" />
                                }
                                <FormNavigator
                                    back={isFirst ? baseResource : `${resource}/${String(index - 1)}`}
                                    continue={`${resource}/${String(index + 1)}`}
                                    isLast={isLast}
                                    onSubmit={this.props.handleSubmit}
                                    disabled={disableProgress}
                                />
                            </Fragment>
                        }
                    />
                }
                sideContent={
                    <Fragment>
                        <Progress
                            steps={steps.map((step) => step.nav)}
                            resource={`${resource}/`}
                            max={this.state.max}
                            title="Fill in Your information to continue the matching progress"
                            current={index}
                            disableProgress={disableProgress}
                        />
                    </Fragment>
                }
            />
        );
    }

}

export default connect(
    (state, props) => ({
        announcementState: state.landlord.announcementState,
        formValues: getFormValues(props.form)(state)
    }),
    dispatch => ({
        manualSubmit: (form) => dispatch(submit(form)),
        resetState: (form) => {
            dispatch(setAnnouncementState(requestState.none));
            dispatch(reset(form))
        }
    })
)(reduxForm({
    destroyOnUnmount: false
})(LandlordProperty));